import { polymorphic } from '../functions/polymorphic.js';
export const Box = polymorphic.div('');
